import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

// 비로그인 전용 라우트 (로그인/가입 화면).
// 이미 로그인한 사용자가 URL 로 직접 접근하면 홈으로 돌려보낸다.
// 로그인 상태로 다시 로그인하면 토큰이 새로 발급되며 refresh token rotation 과
// 세션이 겹쳐 꼬일 수 있어 진입 자체를 막는다.
// 주의: /oauth/complete 는 네이버 콜백 중간 상태를 처리하므로 이 가드를 걸지 않는다.
const PublicOnlyRoute = ({ children }) => {
    const { user, token } = useContext(AuthContext);

    if (token && user) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PublicOnlyRoute;
